import { IntakeData } from '../context/IntakeContext'

export function validateStep(
  step: number,
  data: IntakeData,
): { isValid: boolean; errors: string[] } {
  const errors: string[] = []

  switch (step) {
    case 2: // Contactgegevens
      if (!data.contactName.trim()) errors.push('Naam is verplicht')
      if (!data.contactEmail.trim()) errors.push('E-mailadres is verplicht')
      if (data.contactEmail && !isValidEmail(data.contactEmail))
        errors.push('Ongeldig e-mailadres')
      if (!data.contactPhone.trim()) errors.push('Telefoonnummer is verplicht')
      if (!data.isOwner) errors.push('Geef aan of u eigenaar bent')
      if (!data.isDecisionMaker) errors.push('Geef aan of u de beslisser bent')
      break

    case 3: // Team
      if (!data.showTeamOnWebsite)
        errors.push('Geef aan of het team op de website moet')
      break

    case 4: // Bedrijfsgegevens
      if (!data.companyName.trim()) errors.push('Bedrijfsnaam is verplicht')
      if (!data.mainCity.trim()) errors.push('Stad is verplicht')
      break

    case 5: // Verhaal & Positionering
      if (!data.difference.trim()) errors.push("USP's zijn verplicht")
      if (!data.coreValues.trim()) errors.push('Kernwaarden zijn verplicht')
      break

    case 6: // Juridisch
      if (!data.hasLegalDocs)
        errors.push('Geef aan of u juridische documenten heeft')
      // If they have docs, they must select which ones
      if (data.hasLegalDocs === 'yes' && data.legalDocsList.length === 0) {
        errors.push('Selecteer welke documenten u beschikbaar heeft')
      }
      // If they don't have docs, they must choose an approach
      if (data.hasLegalDocs === 'no' && !data.legalDocsApproach) {
        errors.push('Kies hoe u de documenten wilt aanpakken')
      }
      // If they don't have docs, they must select which ones they need
      if (data.hasLegalDocs === 'no' && data.legalDocsNeeded.length === 0) {
        errors.push('Selecteer welke documenten u nodig heeft')
      }
      break

    case 7: // Branding
      if (!data.hasIdentity) errors.push('Geef aan of u een huisstijl heeft')
      break

    case 8: // Doelen
      if (!data.mainGoal) errors.push('Primair doel is verplicht')
      if (data.mainGoal === 'other' && !data.mainGoalOther.trim())
        errors.push('Vul uw primaire doel in')
      if (!data.targetAudience.trim()) errors.push('Doelgroep is verplicht')
      break

    case 9: // Type Website
      if (!data.websiteType) errors.push('Type website is verplicht')
      break

    case 10: // Pagina's
      if (data.neededPages.length === 0 && data.customPages.length === 0) {
        errors.push('Selecteer minimaal één pagina')
      }
      break

    case 11: // Content
      if (data.existingContent.length === 0)
        errors.push('Geef aan hoe u content aanlevert')
      break

    case 12: // Techniek
      if (!data.domainOwned) errors.push('Geef aan of u een domeinnaam heeft')
      if (data.domainOwned === 'yes' && !data.domainName.trim())
        errors.push('Vul uw domeinnaam in')
      if (data.domainOwned === 'yes' && !data.websiteOfflineAcceptable) {
        errors.push('Geef aan of de website offline mag tijdens de bouw')
      }
      if (data.domainOwned === 'no' && data.desiredDomains.length === 0) {
        errors.push('Voeg minimaal één gewenste domeinnaam toe')
      }
      if (!data.hostingActive) errors.push('Kies een hosting optie')
      break

    case 13: // SEO
      if (!data.seoServices) errors.push('Geef aan hoe belangrijk SEO is')
      break

    case 14: // Planning
      if (!data.launchDate.trim())
        errors.push('Gewenste live datum is verplicht')
      break

    default:
      break
  }

  return {
    isValid: errors.length === 0,
    errors,
  }
}

function isValidEmail(email: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return emailRegex.test(email)
}
